/**
 * Replaces MaterializeAction for modal open/close.
 * Compatible with previous usage: emit({ action: 'modal', params: ['open'] }) or params: ['close'].
 */
export interface ModalAction {
  action: string;
  params: string[];
}
